import React from 'react';
import { useNavigate } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import PublicWrapper from "../public-wrapper/public-wrapper";
import useErrorMsgGeneralStyles from "./error-msg-general.styles";
import STATIC_TEXT from '../../content/common.json';
import BANNER_IMG_URL_RECTANGLE from '../../assets/Rectangle_122.png';


export const ErrorMsgGeneral = () => {
    const classes = useErrorMsgGeneralStyles();
    const navigate = useNavigate();

    const onTryAgainBtnClick = () => {
        navigate(-1);
    };

    return (
        <PublicWrapper
            data-testid="publicWrapper"
            bannerImgUrlRectangleRocket={BANNER_IMG_URL_RECTANGLE}
            displayPrivacyPolicyFooter={true}
            inUsPage={true}
            secondaryContent={(
                <>
                    <Typography variant="h2" style={{ width: '657px', fontWeight: '700', fontSize: '48px', color: '#212121', marginTop: '106px' }}>
                        {STATIC_TEXT.errorMsgGeneral.title}
                    </Typography>
                </>
            )}
            content4={(
                <>
                    <Typography variant="h2" style={{ width: '657px', fontWeight: '500', fontSize: '20px', color: '#212121'}}>
                        <p>
                          Let’s start over from the beginning. If you keep landing on this page, please reach out to your relationship manager or [<span className={classes.supportEmailText}>support@email.com</span>]
                        </p>
                    </Typography>
                </>
            )}
            button={(
                <>
                    <Button
                        className={classes.tryAgainBtn}
                        onClick={onTryAgainBtnClick}
                    >
                        {STATIC_TEXT.errorMsgGeneral.tryAgainButton}
                    </Button>
                </>
            )}
        />
    );
}